import React, { useState, useEffect } from "react";

const PaginationControls = ({ currentPage, pageSize = 50, totalRows, setCurrentPage }) => {
  const [inputValue, setInputValue] = useState(String(currentPage + 1));

  useEffect(() => {
    setInputValue(String(currentPage + 1));
  }, [currentPage]);

  if (totalRows <= pageSize) return null;

  const totalPages = Math.ceil(totalRows / pageSize);
  const start = currentPage * pageSize;
  const end = Math.min(start + pageSize, totalRows);

  const handleGoToPage = () => {
    const page = parseInt(inputValue, 10);
    if (isNaN(page)) {
      setInputValue(String(currentPage + 1));
      return;
    }
    const clamped = Math.max(1, Math.min(page, totalPages));
    setCurrentPage(clamped - 1);
    setInputValue(String(clamped));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleGoToPage();
    }
  };

  return (
    <div
      className="flex align-items-center justify-content-end gap--16"
      style={{ marginBlock: "16px" }}
    >
      <span className="t--sm t--subtitle">{`Showing ${start + 1}–${end} of ${totalRows}`}</span>
      <button
        className="btn btn--sm btn--outline btn--white"
        disabled={currentPage === 0}
        onClick={() => setCurrentPage(currentPage - 1)}
      >
        Previous
      </button>
      <div className="flex align-items-center gap--8">
        <input
          type="text"
          className="pagination__input"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={handleGoToPage}
          onKeyDown={handleKeyDown}
        />
        <span className="t--sm t--subtitle">{`of ${totalPages}`}</span>
      </div>
      <button
        className="btn btn--sm btn--outline btn--white"
        disabled={currentPage >= totalPages - 1}
        onClick={() => setCurrentPage(currentPage + 1)}
      >
        Next
      </button>
    </div>
  );
};

export default PaginationControls;
